// EventList.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEvents } from '../../Redux/Actions/actions';
import styles from './EventList.module.css';

const EventList = () => {
  const dispatch = useDispatch();
  const eventos = useSelector(state => state.events);
  const loading = useSelector(state => state.eventsLoading);
  const error = useSelector(state => state.eventsError);

  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  return (
    <div className={styles.listContainer}>
      <h2 className={styles.title}>Eventos</h2>
      {loading && <p>Cargando eventos...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <ul className={styles.list}>
        {eventos.map(ev => (
          <li key={ev.id} className={styles.item}>
            <div>
              <strong>{ev.titulo}</strong> <span className={styles.fecha}>{ev.fecha}</span>
            </div>
            <div className={styles.descripcion}>{ev.descripcion}</div>
            <div className={styles.horas}>
              {ev.horaInicio} - {ev.horaFin}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EventList;